import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import apiService from '../services/api';

const SCHOOL_ID_RE =
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

const HOME_BUTTON = '#00C8FF';

export function readSchoolId(searchParams) {
  const raw = String(
    searchParams.get('schoolId') ||
      searchParams.get('schoolID') ||
      searchParams.get('school_id') ||
      '',
  ).trim();
  return SCHOOL_ID_RE.test(raw) ? raw : '';
}

export function authHref(path, schoolId, extra) {
  const params = new URLSearchParams();
  if (schoolId) params.set('schoolId', schoolId);
  if (extra) {
    Object.keys(extra).forEach((key) => {
      const value = String(extra[key] || '').trim();
      if (value) params.set(key, value);
    });
  }
  const query = params.toString();
  return query ? `${path}?${query}` : path;
}

export function shortSchoolName(name) {
  return String(name || '').replace(/\s+(university|college)$/i, '').trim();
}

export function possessiveSchool(name) {
  const base = shortSchoolName(name);
  if (!base) return 'your school';
  return /s$/i.test(base) ? `${base}'` : `${base}'s`;
}

function homeBrand(schoolId) {
  return {
    schoolId: schoolId || '',
    isSchool: false,
    ready: true,
    name: '',
    logoUrl: '',
    buttonColor: HOME_BUTTON,
    buttonTextColor: '#ffffff',
  };
}

export function useSchoolBrand() {
  const [searchParams] = useSearchParams();
  const schoolId = readSchoolId(searchParams);
  const [brand, setBrand] = useState(() =>
    schoolId ? { ...homeBrand(''), schoolId, ready: false } : homeBrand(''),
  );

  useEffect(() => {
    if (!schoolId) {
      setBrand(homeBrand(''));
      return undefined;
    }

    let cancelled = false;
    setBrand((current) => ({ ...current, schoolId, ready: false }));

    apiService
      .getPublicSchoolBranding(schoolId)
      .then((config) => {
        if (cancelled) return;
        const name = String(config?.schoolName || '').trim();
        const logoUrl = String(
          config?.headerLogoUrl || config?.logoUrl || config?.schoolImageUrl || '',
        ).trim();
        const buttonColor = String(
          config?.loginButtonColor ||
            config?.buttonColor ||
            config?.primaryColor ||
            config?.inApp ||
            '#1565C0',
        ).trim();
        const buttonTextColor = String(config?.loginButtonTextColor || '#ffffff').trim();
        setBrand({
          schoolId,
          isSchool: true,
          ready: true,
          name: name || 'your school',
          logoUrl,
          buttonColor: buttonColor || '#1565C0',
          buttonTextColor: buttonTextColor || '#ffffff',
        });
      })
      .catch(() => {
        if (!cancelled) setBrand(homeBrand(schoolId));
      });

    return () => {
      cancelled = true;
    };
  }, [schoolId]);

  return brand;
}
